var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgTh = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 640 480"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#f4f5f8",
  d: "M0 0h640v480H0z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#2d2a4a",
  d: "M0 162.5h640v160H0z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#a51931",
  d: "M0 0h640v82.5H0zm0 400h640v80H0z"
}))));
export { SvgTh as ReactComponent };
export default __webpack_public_path__ + "assets/images/th.d3dea0cee87c83e3a1e65baf0081b1e3.svg";